import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { CommandButton } from '@fluentui/react/lib/Button';
import EventScope from 'owa-service/lib/contract/EventScope';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import getDefaultStart from 'owa-calendar-forms-common/lib/utils/getDefaultStart';
import { getCalendarFolderIdForCompose } from 'owa-calendar-forms-utils/lib/utils/getCalendarFolderIdForCompose';
import { getFirstFocusable } from '@fluentui/react/lib/Utilities';
import { tryShowQuickCompose } from 'owa-calendar-quick-compose/lib/actions/tryShowQuickCompose';
import { OwaDate } from 'owa-datetime';
import { getCalendarIds, getEntrySource } from '../selectors/agendaStoreSelectors';
import { getDensityModeString } from 'owa-fabric-theme';

import styles from './AgendaListDateMessage.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface AgendaListDateMessageProps {
    text: string;
    date: OwaDate;
    scenarioId: string;
    buttonText: string;
}

export const AgendaListDateMessage = observer(function AgendaListDateMessage(
    props: AgendaListDateMessageProps
) {
    const { text, date, scenarioId, buttonText } = props;
    const calendarIds = getCalendarIds(scenarioId);
    const composeCalendarFolderId = getCalendarFolderIdForCompose(calendarIds);

    const newEventOnClick = React.useCallback(() => {
        let initialCalendarEvent = {
            Start: getDefaultStart(date),
            ParentFolderId: composeCalendarFolderId,
        } as CalendarEvent;

        tryShowQuickCompose(
            initialCalendarEvent,
            getEntrySource(scenarioId),
            EventScope.Default,
            getNewEventButtonAnchorElement(scenarioId, date)
        );
    }, [composeCalendarFolderId]);

    return (
        <div className={classNames(styles.container, getDensityModeString())}>
            <div className={classNames(styles.dateMessage, getDensityModeString())}>{text}</div>
            {composeCalendarFolderId && (
                <CommandButton
                    className={classNames(styles.createNewEvent, getDensityModeString())}
                    onClick={newEventOnClick}
                    id={getNewEventButtonAnchorId(scenarioId, date)}>
                    {buttonText}
                </CommandButton>
            )}
        </div>
    );
});

function getNewEventButtonAnchorElement(scenarioId: string, date: OwaDate) {
    const anchorName = getNewEventButtonAnchorId(scenarioId, date);
    const newEventButtonElem = document.getElementById(anchorName) as HTMLElement;
    return getFirstFocusable(newEventButtonElem, newEventButtonElem, true) as HTMLDivElement;
}

function getNewEventButtonAnchorId(scenarioId: string, date: OwaDate) {
    return scenarioId + date.toString() + '_CreateNewEventButton';
}
